enum ModalReducerEnum {
  SET_VISIBLE = 0,
  SET_INVISIBLE = 1,
}

export default ModalReducerEnum;
